import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import CapsuleCard from '../components/CapsuleCard'
import { getCapsuleById } from '../lib/supabase'
import './CapsulePage.css'

export default function CapsulePage() {
  const navigate = useNavigate()
  const { capsuleId } = useParams()
  const [searchParams] = useSearchParams()

  const [capsule, setCapsule] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      setLoading(true)
      setError('')
      try {
        const data = await getCapsuleById(capsuleId)
        if (cancelled) return
        if (!data) {
          setError('Post not found.')
          return
        }
        setCapsule(data)
      } catch (e) {
        if (cancelled) return
        console.error('Failed to load capsule:', e)
        setError(e.message || 'Could not load post.')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    return () => { cancelled = true }
  }, [capsuleId])

  const autoOpenResponses = searchParams.get('view') === 'responses'

  return (
    <div className="capsulepage-page">
      <header className="capsulepage-header">
        <button className="capsulepage-back-btn" onClick={() => navigate(-1)}>← Back</button>
        <div className="capsulepage-header-title-wrap">
          <div className="capsulepage-header-title">Post</div>
          <div className="capsulepage-header-subtitle">Discussion thread</div>
        </div>
      </header>

      <main className="capsulepage-body">
        {loading && (
          <div className="capsulepage-loading"><span className="spinner" /></div>
        )}

        {!loading && error && (
          <div className="capsulepage-empty">
            <div className="capsulepage-empty-glyph">◇</div>
            <div>{error}</div>
          </div>
        )}

        {!loading && capsule && (
          <CapsuleCard capsule={capsule} autoOpenResponses={autoOpenResponses} />
        )}
      </main>
    </div>
  )
}
